<template>
    <InertiaLink :href="'/product/'+product.slug" class="flex flex-col justify-center items-center w-full group cursor-pointer">
        <div class="relative overflow-hidden w-full rounded-md shadow-md bg-cover bg-center bg-no-repeat group-hover:shadow-xl transition duration-300">
            <img
                :src="getProductImage(product.sortedImages)"
                class="w-full h-full object-contain transform scale-100 group-hover:scale-110 transition duration-300"
            />
            <!-- logo-color -->
            <div class="bg-gray-900 bg-opacity-10 absolute top-0 bottom-0 left-0 right-0 group-hover:bg-opacity-0 transition duration-300"></div>
        </div>
        <div class="w-10/12 bg-gray-100 -mt-10 shadow-lg rounded-md overflow-hidden z-10 sm:text-base text-xs"
        >
            <div class="py-2 text-center font-bold tracking-wide text-gray-700" >
                <div
                    class="line-clamp"
                    :class="{
                        'text-base' : product.name.length < 50,
                        'text-sm' : product.name.length < 150,
                        'text-xs': product.name.length > 150,
                    }"
                v-html="product.name"></div>
            </div>
            <div class="flex items-center justify-between py-2 px-3 bg-red-700">
                <h1 class="text-gray-200 font-bold">{{ product.pieces_type != 'packages' ? getPrice(product.price) : getPackagePrice(product.pieces_item) }}</h1>
                <Button
                    :color="null"
                    padding="sm"
                    class="bg-white text-gray-700 font-bold hover:bg-gray-900 hover:text-gray-200"
                >
                    {{ isPersonalize(product.options) ? __('Personalize') : __('Show product')}}
                </Button>
            </div>
        </div>
    </InertiaLink>
</template>

<script>
import Button from 'UI/Button';

import {
    getPrice,
    getPackagePrice,
    isPersonalize,
    getProductImage,
} from 'helper';

export default {
    components: { Button },
    props: ['product'],

    methods: {
        getPrice,
        getPackagePrice,
        isPersonalize,
        getProductImage,
    },
    // setup(props) {
    //     console.log(props.product.name)
    // }
}
</script>
<style scoped>
.line-clamp {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
</style>
